export default __webpack_public_path__ + "static/media/fruits-2.ff212b36.png";